import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-media-lab',
  templateUrl: './media-lab.component.html',
  styleUrls: ['./media-lab.component.scss']
})
export class MediaLabComponent implements OnInit {
  activeLightboxImage: string | null = null;

  mediaImages = [
    '/assets/img/facilities/imgi_143_BAJMC_1-1200x800.jpg',
    '/assets/img/facilities/imgi_140_BAJMC_2-1200x800.jpg',
    '/assets/img/facilities/imgi_137_BAJMC_3-1067x800.jpg'
  ];

  constructor() { }

  ngOnInit(): void { }

  openLightbox(src: string): void {
    this.activeLightboxImage = src;
  }

  closeLightbox(): void {
    this.activeLightboxImage = null;
  }
}

